module.exports = __webpack_public_path__ + "img/certificate3.c15ef22e.jpg";